import { Icon, IconType, ListItem } from '@lmc/ui-kit'
import { Dropdown } from 'antd'
import DotsButton from '../DotsMenu/DotsMenu'
import { goalsConstants } from 'locale/goals'
import { useTranslation } from 'react-i18next'
import { NAMESPACE } from 'locale'
import dayjs from 'dayjs'
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal'

type DocumentItemProps = {
  onUnlink: () => void
  onEdit: () => void
  name: string
  // Date is here because of wrong type from Document
  createdAt?: string | Date
  disabled: boolean
  onClick: (() => void) | undefined
  hasBorder?: boolean
  testId?: string
}

const DocumentItem = (props: DocumentItemProps) => {
  const {
    onUnlink,
    onEdit,
    name,
    createdAt,
    disabled,
    onClick,
    hasBorder,
    testId
  } = props
  const baseId = testId || 'document-item'

  const { t } = useTranslation(NAMESPACE.GOALS)

  const createdDate = dayjs(createdAt)
  const daysPassed = dayjs().diff(createdDate, 'day')

  const subtitle = daysPassed
    ? t(goalsConstants.ADDED_X_DAYS_AGO, { days: daysPassed })
    : t(goalsConstants.ADDED_TODAY)

  const dropdownMenu = {
    items: [
      {
        key: '1',
        label: t(goalsConstants.EDIT),
        onClick: () => onEdit()
      },
      {
        key: '2',
        label: (
          <ConfirmationModal>
            <div onClick={onUnlink}>{t(goalsConstants.UNLINK)}</div>
          </ConfirmationModal>
        )
      }
    ]
  }

  return (
    <ListItem
      iconContent={<Icon customIcon={IconType.SideDocuments} />}
      titleContent={name}
      subTitleContent={subtitle}
      onClick={onClick}
      hasBorder={hasBorder}
      data-testid={baseId}
    >
      {disabled || (
        <Dropdown trigger={['click']} menu={dropdownMenu}>
          <DotsButton data-testid={`${baseId}-dots`} />
        </Dropdown>
      )}
    </ListItem>
  )
}

export default DocumentItem
